import { autoinject, bindable, bindingMode, transient } from 'aurelia-framework';
import { BaseView } from 'Common/BaseView';

@autoinject
export class HomeBaseView extends BaseView {

    constructor() {
        super();

    }
    async bind() {
    }

    attached() {
    }

    detached() {
    }

}